import React from 'react'
import { SettingsType } from '.'
import { SettingsMore } from './SettingsMore'
import { SettingsOutline } from './SettingsOutline'
import { useFontSettings } from '../../LeftWorkArea/LeftWorkText/useFontSettings'
import { SettingsLayers } from './SettingsLayers'
import { ColorArray } from '../ColorArray'
import { SettingsColor } from './SettingsColor'
import { SettingsFont } from './SettingsFont'
import { EditText } from './EditText'

interface SettingsProps {
    type: SettingsType
}

export const Settings = (props: SettingsProps) => {
    const { type } = props

    const { more, edit } = useFontSettings();

    return <>
        {type === 'more' ? <SettingsMore {...more} /> : null}
        {type === 'outline' ? <SettingsOutline /> : null}
        {type === 'layers' ? <SettingsLayers /> : null}
        {type === 'color'? <SettingsColor/> : null}
        {type === 'font'? <SettingsFont/> : null}
        {type === 'edit'? <EditText {...edit}/>: null}
    </>
}